<template>
  <el-tooltip :value="isOpen" :content="status.explanation" placement="top" effect="dark" manual popper-class="dealer-wait-status-tooltip">
    <button
      type="button"
      class="tag-level-desing dealer-wait-status-tag"
      :class="status.tone"
      :aria-label="`${status.label}. ${status.explanation}`"
      :aria-expanded="String(isOpen)"
      @pointerenter="openForMouse"
      @pointerleave="closeForMouse"
      @click="togglePinned"
      @keydown.esc="unpin"
    >
      {{ status.label }}<i class="dealer-wait-status-tag__info">i</i>
    </button>
  </el-tooltip>
</template>
<script>
const MOUSE_POINTER = "mouse";

export default {
  name: "DealerWaitStatusTag",
  props: {
    status: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isHovered: false,
    isPinned: false
  }),
  computed: {
    isOpen() {
      return this.isHovered || this.isPinned;
    }
  },
  mounted() {
    document.addEventListener("click", this.unpinOnOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.unpinOnOutsideClick);
  },
  methods: {
    openForMouse(event) {
      this.isHovered = event.pointerType === MOUSE_POINTER;
    },
    closeForMouse() {
      this.isHovered = false;
    },
    togglePinned() {
      this.isPinned = !this.isPinned;
    },
    unpin() {
      this.isPinned = false;
    },
    unpinOnOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.unpin();
      }
    }
  }
};
</script>
<style lang="scss">
.dealer-wait-status-tag {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  border: 0;
  border-radius: 8px;
  padding: 3px 12px;
  font-family: inherit;
  font-weight: 800;
  &.green {
    color: #1f5e3a;
  }
  &.red {
    color: #7a1f1f;
  }
  &.gray {
    background: #e6e6e6 !important;
    color: #555;
  }
}
.dealer-wait-status-tag__info {
  display: inline-grid;
  place-items: center;
  width: 15px;
  height: 15px;
  margin-left: 6px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.18);
  color: #fff;
  font-style: normal;
  font-size: 11px;
}
.dealer-wait-status-tooltip {
  max-width: 280px;
  line-height: 1.4;
}
</style>
